import React, { memo, useState, useEffect, useRef } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

function RowCharts(props) {
  const { data = [], expand } = props;
  const [buyerOption, setBuyerOption] = useState({});
  const [targetOption, setTargetOption] = useState({});

  const [buyerChartRef, targetChartRef] = [useRef(), useRef()];
  useEffect(() => {
    setBuyerOption({ ...data[0] });
    setTargetOption({ ...data[1] });
  }, [data]);

  useEffect(() => {
    // eslint-disable-next-line no-unused-expressions
    buyerChartRef.current?.chart.reflow();
    // eslint-disable-next-line no-unused-expressions
    targetChartRef.current?.chart.reflow();
  }, [expand]);

  return (
    <div className="highchart-container segments-container">
      <div className="chart-content">
        {buyerOption.series &&
        buyerOption.series.length !== 0 &&
        buyerOption.series[0].data.length !== 0 ? (
          <div className="segments-chart-wrapper">
            <HighchartsReact
              highcharts={Highcharts}
              options={buyerOption}
              ref={buyerChartRef}
            />
          </div>
        ) : (
          <div className="no-data">No Data</div>
        )}
      </div>
      <div className={expand ? 'vertical-seperator' : 'row-seperator'} />
      <div className="chart-content">
        {targetOption.series &&
        targetOption.series.length !== 0 &&
        targetOption.series[0].data.length !== 0 ? (
          <div className="segments-chart-wrapper">
            <HighchartsReact
              highcharts={Highcharts}
              options={targetOption}
              ref={targetChartRef}
            />
          </div>
        ) : (
          <div className="no-data">No Data</div>
        )}
      </div>
    </div>
  );
}

export default memo(RowCharts);
